import { render, staticRenderFns } from "./CreateEditShowcaseWidget.vue?vue&type=template&id=c1bd2030&"
import script from "./CreateEditShowcaseWidget.vue?vue&type=script&lang=js&"
export * from "./CreateEditShowcaseWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports